import React, { PropsWithChildren } from 'react';
import { Container } from './style';
import { ModuleContainerProps } from './type';

const ModuleContainer = ({
  children,
  containerType
}: PropsWithChildren<ModuleContainerProps>) => (
  <Container data-testid="cmp-module-container" containerType={containerType}>
    {children}
  </Container>
);

export default ModuleContainer;
